import { AToastDispatcher } from 'core_a-toast';

export default ({ app, store }, inject) => {
  inject('toast', {
    ...AToastDispatcher
  });
};
